<template>
    <div class="searchCar">
        <topNav v-show="isShow" :title="title"></topNav>
        <div :class="['pic-container',{'scale':isScale}]">
            <!-- <searchCarMap :datas="mapData" @myEvent="changeEvent"></searchCarMap> -->
            
            <div class="map-container" >
                <img :src="imgUrl" alt="" @click.stop="openView">
                <div class="marker" :style="'top:'+y+'%;left:'+x+'%;'"></div>
            </div>

        </div>
        <ul class="txt">
            <li><b>{{searchCarNum}}</b></li>
            <li>车位描述 ：<span>{{mapName+"-"+carportNum}}</span></li>
            <li>车场名称 ：<span>{{carportName}}</span></li>
        </ul>
        
        <div class="pic-bg" v-show="isScale">
            <div class="top">
                <div class="close" @click.stop="closeView">×</div>
            </div>
            <div class="pic-map-container" >
                <div id="picView" class="pic-view" :style="'width:'+boxWidth+'%;height:'+boxHeight+'px;transform: translate3d('+viewX+'px, '+viewY+'px, 0px) scale('+viewScale+');'">
                    <img :src="imgUrl" alt="">
                    <div class="marker" :style="'top:'+y+'%;left:'+x+'%;'"></div>
                </div>
                
            </div>
        </div>
        
    </div>
</template>

<script>
import searchCarMap from "@/components/common/searchCarMap";
import {DETAIL as API} from "@/assets/api";
import topNav from "../topnav/topnav";
export default {
    data(){
        return{
            // lon:"113.903895",//经度
            // lat:"22.582263",//纬度
            lon:"",//经度
            lat:"",//纬度
            mapData:{},
            searchCarNum:null, 
            carportName:"",//车场名称
            carportNum:"",//车位号码
            mapName:"",//楼层名称
            myStatus:0,
            isScale:false,
            isShow:true,
            title:"寻车路线",
            timeOut:false,//请求地理位置是否超时

            
            imgUrl:"",
            x:0,
            y:0,
            isScale:false,//是否缩放
            maxHeight:400,
            clickCount:0,
            boxWidth:100,
            boxHeight:210,
            viewX:0,
            viewY:0,
            viewScale:1,
        }
    },
    methods:{
        openView(){
            this.isScale=true;
            this.changeEvent(false)
        },
        closeView(){
            this.isScale = false;
            this.viewX=0;
            this.viewY=0;
            this.viewScale=1;
            this.changeEvent(true)
        },
        changeEvent(e){
            this.isShow = e;
        },
        randPage(){//渲染页面
            let data = sessionStorage.getItem("mapData");
            if(data){
                data=JSON.parse(data)
            }else{
                return;
            }
            this.lon = data.lon;
            this.lat = data.lat;
            this.carportName = data.parkingname;
            this.carportNum = data.pointname;
            this.mapName = data.mapname || '';
            this.mapData = data;
            this.searchCarNum = data.vehicleno;
        },
        getCarDetail(){//获取车辆位置详细
            var req = {
                vehicleno: this.searchCarNum,
                needphoto: 1,
            }
            let originalId = sessionStorage.getItem("originalId");
            if(originalId){
                req.originalId = originalId
            }
            
            this.$http({
                method: 'post',
                url: API.CAR_DETAIL,
                data: this.qs.stringify(req),
                success: function(data){
                    if(data.data && data.code == 0){
                        data = data.data;
                        this.carportName = data.parkingname;
                        this.carportNum = data.pointname;
                        this.mapName = data.mapname;
                        this.mapData = data;
                    }else{
                        this.$dialog.alert({
                            title: '提示',
                            message: data.msg
                        })
                    }
                }.bind(this),
                error: function(error){
                    console.log(error)
                }
            })
        },
    },
    created(){
        
        let queryCarNum = this.commonUtil.getUrlKey("carNum") || sessionStorage.getItem("msgCarNum")
        if(queryCarNum){
            sessionStorage.setItem("msgCarNum",queryCarNum)//通知中带的车牌号

            this.searchCarNum = queryCarNum
            
             let originalId = sessionStorage.getItem("originalId");
            if(originalId){
                this.getCarDetail()
            }
        }
        
    },
    mounted(){
        let carNum = this.commonUtil.getUrlKey("carNum");
        if(!carNum){
            this.randPage();
        }

        let dom = document.getElementById("picView");
        var startY = null; // 滑块开始滑动的水平位置
        var moveEndY = null; // 滑块结束滑动的水平位置
        var startX = null; // 滑块开始滑动的水平位置
        var moveEndX = null; // 滑块结束滑动的水平位置
        var containerHeight = null; // 选项容器的初始高度
        var startScaleX = null; // 
        var startScaleY = null; // 

        // 答题卡滑块事件
        dom.addEventListener("touchstart", (e)=>{
            // 取消默认动作
            e.cancelable && !e.defaultPrevented && e.preventDefault();
            let fingers = e.touches.length;
            // 原生的写法 ： startY = e.touches[0].pageY;
            if(fingers == 1){
                startY = e.touches[0].pageY;
                startX = e.touches[0].pageX;
            }else if(fingers == 2){
                startScaleX = Math.abs(e.touches[0].pageX - e.touches[1].pageX);
                startScaleY = Math.abs(e.touches[0].pageY - e.touches[1].pageY);
            }
        });
        dom.addEventListener("touchmove", (e)=> {
            // 取消默认动作
            e.cancelable && !e.defaultPrevented && e.preventDefault();
            // 原生的写法 ： moveEndY = e.touches[0].pageY;
            moveEndY = e.touches[0].pageY;
            moveEndX = e.touches[0].pageX;
            let fingers = e.touches.length;
            // 移动了的差值
            if(fingers == 1){
                var movedY = moveEndY - startY;
                var movedX = moveEndX - startX;
                startY += movedY;
                startX += movedX;
                Math.abs(this.viewX)
                let maxMove = (dom.offsetWidth*this.viewScale-document.body.clientWidth)/2;
                if(maxMove > Math.abs(this.viewX+movedX)){
                    this.viewX = this.viewX+movedX;
                }
                //this.viewX = this.viewX+movedX;
            }else if(fingers == 2){
                let endScaleX = Math.abs(e.touches[0].pageX - e.touches[1].pageX);
                let endScaleY = Math.abs(e.touches[0].pageY - e.touches[1].pageY);
                let picScaleX = endScaleX - startScaleX;
                let picScaleY = endScaleY - startScaleY;
                let picScale = null;
                
                picScale = this.viewScale + (picScaleY/1000);
                if(picScale >= 1 && picScale <3){
                    this.viewScale = picScale;
                    this.viewX = 0;
                    this.viewY = 0;
                }
                
            }
        });
        dom.addEventListener("touchend", (e)=> {
            // 动态改变文档底部占位符高度
            
        });
    },
    watch:{
        mapData(value,oldValue){
            if(value != oldValue){
                this.imgUrl = value.url;
                this.x=parseFloat(value.x)*100;
                this.y= parseFloat(value.y)*100;
                let dom = document.getElementsByClassName(".marker")[0];
            }
        }
    },
    components:{
        searchCarMap,
        topNav
    }
}
</script>

<style>
.searchCar .pic-container {
    width: 100%;
    height: 210px;
    margin: 0 auto;
    background: #ddd;
    overflow: auto;
}
.searchCar .pic-container.scale{
    height: auto;
}
.searchCar .pic-container::-webkit-scrollbar {
    display: none;
}
.searchCar .txt li{
    height: 30px;
    line-height: 30px;
    color: #333;
    padding: 0 20px;
    color: rgb(102,102,102);
    font-size: 12px;
    text-align: left;
}
.searchCar .txt li span{
    float: right;
}
.searchCar .txt li:first-child{
    height: 45px;
    padding-top: 20px;
}
.searchCar .txt li:first-child b{
    display: block;
    margin: 0 auto;
    width: 118px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    color: rgb(70,135,238);
    font-size: 18px;
    border: 1px solid #ddd;
    border-radius: 4px;
}
</style>



<style>
    .map-container{
        width: 100%;
        height: 210px;
        position: relative;
        -webkit-overflow-scrolling: touch;
    }
    .map-container.scale{
        width: 200%;
        height: 420px;
    }
    .map-container img{
        width:100%;
        height:100%;
    }
    .map-container .marker{
        width:16px;
        height: 16px;
        margin-left: -5px;
        margin-top: -5px;
        border-radius: 10px;
        position: absolute;
        background:url("../../../static/images/marker.svg") no-repeat 3px 4px;
        background-size: 10px;
        border: 1px solid #D81E06;
    }
    .pic-bg{
        position: fixed;
        top:0;
        left: 0;
        right: 0;
        bottom: 0;
        background: #000;
        z-index: 999;
    }
    .pic-bg .pic-map-container{
        overflow: auto;
        width: 100%;
        height: 100vh;
        line-height: 100vh;

    }
    .pic-bg .pic-map-container::-webkit-scrollbar {
        display: none;
    }
    .pic-bg .pic-map-container .pic-view{
        display: inline-block;
        width: 100%;
        height: 210px;
        position: relative;
        vertical-align: middle;
        transform: translate3d(0px, 0px, 0px) scale(1);
    }
    .pic-bg .pic-map-container .pic-view img{
        width: 100%;
        vertical-align: top;
    }
    .pic-bg .pic-map-container .pic-view .marker{
        width:16px;
        height: 16px;
        margin-left: -5px;
        margin-top: -5px;
        border-radius: 10px;
        background: rgb(70,135,248);
        position: absolute;
        background:url("../../../static/images/marker.svg") no-repeat 3px 4px;
        background-size: 10px;
        border: 1px solid #D81E06;
    }
    .pic-bg .top{
        position: absolute;
        left: 0;
        top: 0;
        height: 44px;
        width: 100%;
    }
    .pic-bg .top .close{
        width: 44px;
        height: 44px;
        position: absolute;
        background: none;
        cursor: pointer;
        overflow: visible;
        -webkit-appearance: none;
        display: block;
        border: 0;
        padding: 0;
        margin: 0;
        float: right;
        opacity: .75;
        transition: opacity .2s;
        box-shadow: none;
        font-size: 36px;
        color: #fff;
        line-height: 44px;
        right: 0;
        z-index: 10;
    }
</style>


// WEBPACK FOOTER //
// src/components/searchCar/searchCarDetail.vue